import { routePaths } from 'routes/paths'

export enum FeedbackPageType {
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}

export enum FeedbackPageFlow {
  LEAD_FORM = 'LEAD_FORM',
}

export type FeedbackPageContent = {
  title: string
  description?: string
  primaryButton: string
}

export type FeedbackPageData = Record<
  string,
  { [flow in FeedbackPageFlow]?: { [type in FeedbackPageType]?: FeedbackPageContent } }
>

export type FeedbackReturnType = 'redirect' | 'deeplink' | 'goback'

export const feedbackRoutes: Record<FeedbackPageFlow, { type: FeedbackReturnType; route: string }> =
  {
    [FeedbackPageFlow.LEAD_FORM]: { type: 'redirect', route: routePaths.leadForm },
  }
